// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"366":"4a1777b0","461":"849eafb1","755":"d08e40ba","807":"a8639174"}[chunkId] + ".css";
};